import { CWReadOnlyModel } from 'core/models/cwReadOnly.model';

export class CWProfilutilisateurWorkflow extends CWReadOnlyModel {

}
